'use client';
import { Card, CardHeader, CardBody, Divider, Popover, PopoverContent, PopoverTrigger, Chip } from "@heroui/react";
import { GaugeCircle } from './ui/gauge-circle';
import Logo from './svgs/Logo';
import { CircleHelp } from 'lucide-react';
import Link from 'next/link';
import { format } from 'date-fns';
import { getColor } from '../lib/utils/ColorHelper';

export function TrustScoreProgress({
    hasScore = true,
    metrics = {
        trust_score: 70,
    },
    companyName,
    uen,
    entityStatus,
}: {
    hasScore: boolean;
    metrics?: {
        trust_score: number;
    };
    companyName: string;
    uen: string;
    entityStatus?: string;
}) {
    return (
        <Card radius="md">
            <CardHeader className="bs flex flex-col items-center gap-2">
                <div className="w-36">
                    <Logo />
                </div>
                <div className="flex flex-row items-center gap-2">
                    <h2 className="font-semibold">TrustScore</h2>
                    <Popover>
                        <PopoverTrigger>
                            <div onClick={(e) => e.stopPropagation()}>
                                <CircleHelp size={20} />
                            </div>
                        </PopoverTrigger>
                        <PopoverContent>
                            The TrustScore indicates the reliability and security of an organisation at a glance for a swift and comprehensive assessment
                            leveraging Scam.SG&apos;s proprietary algorithm. The scale ranges from 1 to 100, where 1 indicates the
                            highest risk and 100 indicates the lowest risk.
                        </PopoverContent>
                    </Popover>
                </div>
            </CardHeader>

            <CardBody className="items-center justify-center bg-white text-center">
                <div className="relative mx-auto flex flex-col items-center justify-start gap-x-16 lg:flex-row">
                    <GaugeCircle
                        max={100}
                        min={0}
                        value={hasScore ? metrics.trust_score : 0}
                        gaugePrimaryColor={hasScore ? getColor(metrics.trust_score, 'hex') : '#0000'}
                        gaugeSecondaryColor={hasScore ? 'rgba(0, 0, 0, 0.1)' : '#0000'}
                    />
                    {!hasScore && (
                        <div className="absolute inset-0 flex justify-center">
                            <span className="text-base font-semibold">Score Not Available</span>
                        </div>
                    )}
                    {hasScore && metrics.trust_score === null && (
                        <div className="absolute inset-0 flex justify-center">
                            <span className="text-base font-semibold">Under Review</span>
                        </div>
                    )}
                </div>
                <div className="mt-4">
                    <p className="font-semibold">{companyName}</p>
                    <p className="text-sm text-gray-700">UEN:{uen}</p>
                    {entityStatus && !entityStatus.toLowerCase().includes('live') && (
                        <div className="bg-warning-50 px-2 py-1 text-warning-700">
                            <p className="text-sm font-semibold">Company is no longer operational</p>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
}
